import React, { useContext } from "react"
import { ActiveModuleName, UserMenu } from '../../../mtska-frontend-app-component'
import { AppContext } from '../../contexts'
import { useTranslation } from 'react-i18next'
import { HamburgerMenu } from "src/mtska-frontend-app-component/components/Menu/HamburgerMenu"
import { Box } from '@mui/joy'

const Header = () => {

    const { t, i18n } = useTranslation()
    const safeT = (key, fallback = key, options) => {
        const lang = i18n.resolvedLanguage || i18n.language || 'it';
        const translatedValue = i18n.getResource(lang, 'translation', key);
        return translatedValue !== undefined ? t(key, options) : fallback;
    };

    const { currentModuleName, currentModuleScope, appConfiguration, innerWidth } = useContext(AppContext)

    const currentModuleLabel = safeT(currentModuleName, currentModuleName);
    document.title = safeT(
        appConfiguration.app.pageTitle,
        appConfiguration.app.pageTitle?.replace('{{cmn}}', currentModuleLabel),
        { cmn: currentModuleLabel }
    )

    return (
        <header>
            <ActiveModuleName currentModuleName={currentModuleName} currentModuleScope={currentModuleScope} logo={appConfiguration.app.logoSvg} />
            <div className="filler"></div>
            {/* <div>{JSON.stringify(appConfiguration)}</div> */}
            {innerWidth <= 600 && (
                <Box sx={{ alignContent: 'center' }}>
                    <HamburgerMenu renderContent={() => <UserMenu />} />
                </Box>
            )}
        </header>
    )
}

export default Header
